import { Box, Box2 } from './SideInfoStyle';
import { ISBoxProps } from './SideInfo';

export const SBox = (data: ISBoxProps) => {
  return <Box>{data.children}</Box>;
};

export const SBox2 = (data: ISBoxProps) => {
  return <Box2>{data.children}</Box2>;
};